<template>
  <window-default ref="window" :resolve="find" :proccessData="proccessData" :mock="mock" :props="props" v-slot="{data}"
                  @loaded="(obj) => model = obj" @save="save">
    <window-body class="wrapper-lg">
      <e-row mr>
        <e-col size="1">
          <erp-s-field
              label="ID:"
          >
            <erp-input v-model="model.id" size="2" readonly />
          </erp-s-field>
        </e-col>
      </e-row>

      <e-row mr>
        <e-col>
          <erp-s-field
              label="Nome:"
          >
            <erp-input autofocus v-model="model.name" size="2" />
          </erp-s-field>
        </e-col>
      </e-row>

      <e-row mr>
        <e-col>
          <erp-s-field
              label="Prioridade:"
          >
            <erp-select v-model="model.priority" :options="priorityOpts" />
          </erp-s-field>
        </e-col>
      </e-row>

      <e-row mr>
        <e-col>
          <erp-s-field
              label="Ativo:"
          >
            <erp-checkbox v-model="model.active" />
          </erp-s-field>
        </e-col>
      </e-row>
    </window-body>
  </window-default>
</template>

<script>
import {WindowBody, ErpSField, ErpInput, ErpSelect, ErpCheckbox} from 'uloc-vue-plugin-erp'
import WindowDefault from '../../../../../reuse/window/Default'
import ERow from '../../../../layout/components/Row'
import ECol from '../../../../layout/components/Col'
import {
  findQueue as find,
  newQueue as _new,
  updateQueue as update,
} from '@/domain/tarefas/services/queue'
import save from '../../../helpers/save'
import {FILA_PRIORITY} from "@/domain/project/helpers/types"

let mock = {
  id: null,
  name: null,
  priority: 0,
  project: null,
  active: true
}

export default {
  name: 'Window',
  components: {
    ECol,
    ERow,
    WindowDefault,
    WindowBody,
    ErpSField,
    ErpInput,
    ErpCheckbox,
    ErpSelect
  },
  props: ['props'],
  data () {
    return {
      model: JSON.parse(JSON.stringify(mock))
    }
  },
  mounted () {
  },
  computed: {
    find () {
      return find
    },
    mock () {
      return mock
    },
    priorityOpts() {
      return Object.keys(FILA_PRIORITY).map(k => {
        return {
          label: FILA_PRIORITY[k].title,
          value: Number(k)
        }
      })
    }
  },
  methods: {
    update: update,
    new: _new,
    save: save,
    proccessData (data) {
      let _mock = JSON.parse(JSON.stringify(this.mock))
      data = Object.assign(_mock, data)
      return data
    },
    beforeSave (data) {
      if (data.project && data.project.id) {
        data.project = data.project.id
      }
      return data
    }
  }
}
</script>
